import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import {
  BUSINESS_VERIFICATION_STATUS_VARIANTS,
  getBusinessVerificationBadgeKey,
} from '../../../lib/stripeConnect'

const TRANSLATION_PREFIX = 'business.stripe.status'

export default function BusinessVerificationBadge({ stripeStatus }) {
  const { t } = useTranslation()
  const badgeKey = getBusinessVerificationBadgeKey(stripeStatus)
  const badgeVariant =
    BUSINESS_VERIFICATION_STATUS_VARIANTS[badgeKey] || 'secondary'

  return (
    <span className={`badge bg-${badgeVariant}`}>
      {t(`${TRANSLATION_PREFIX}.${badgeKey}`, 'Verified')}
    </span>
  )
}

BusinessVerificationBadge.propTypes = {
  stripeStatus: PropTypes.object,
}
